import { DateTime } from 'luxon';
import { useMemo, FunctionComponent } from 'react';

import { TIMEZONES } from '@/core/timezones';
import { WindowedSelect } from '@/form/select';

function getTimezoneMetadata(zone: string) {
  const zonedDate = DateTime.utc().setZone(zone);
  const offsetAsString = zonedDate.toFormat('Z');

  return {
    offset: zonedDate.offset,
    value: zone,
    label: `${zone.replace(/_/g, ' ')} (UTC${offsetAsString})`,
  };
}

const preprocessedTimezones = TIMEZONES.map(getTimezoneMetadata).sort(
  (a, b) => a.offset - b.offset,
);

export const TimezoneField: FunctionComponent<any> = (props) => {
  const { input, ...rest } = props;
  const options = useMemo(() => preprocessedTimezones, []);
  return (
    <WindowedSelect
      options={options}
      value={options.find((option) => option.value === input.value)}
      onChange={(option: any) => input.onChange(option.value)}
      {...rest}
      onBlur={(event) => event.preventDefault()}
    />
  );
};
